export { IrLibraryPage as default } from '@/components/pages/Ir/Library'
